import { Box, ThemeProvider } from "@material-ui/core";
import { useOktaAuth } from "@okta/okta-react";
import React from "react";
import { Outlet } from "react-router";
import LuicdAppBar from "../components/layout/lucidAppBar";
import { darkTheme } from "../components/theme";
import { setAuthTokens } from "../api";

const AuthGuard = () => {
    const { authState, oktaAuth } = useOktaAuth();

    if (authState === null || authState === undefined) {
        return <div> Loading.... </div>;
    }
    if (!authState.isAuthenticated) {
        oktaAuth.signInWithRedirect();
        return <div> Loading.... </div>;
    }
    setAuthTokens(authState.accessToken.accessToken);

    return (
        <ThemeProvider theme={darkTheme}>
            <Box height="100vh" flexDirection="column" display="flex">
                <LuicdAppBar />
                <Outlet />
            </Box>
        </ThemeProvider>
    );
};

export default AuthGuard;
